module.exports = __webpack_public_path__ + "static/media/generative_ai.661e17d3.png";